import styled from 'styled-components';
import CornCropBG from 'assets/images/cornBackgroundImage.png';
import SunflowerCropBG from 'assets/images/Sunflower.png';
import BarleyCropBG from 'assets/images/Barley_BG.png';
import WheatCropBG from 'assets/images/Wheat_BG.png';
import SoyabeanCropBG from 'assets/images/Soyabean_BG.png';

interface HeroBanner0aWrapperProps {
  cropName?: string;
}

const getCropImage = (cropName: string) => {
  switch (cropName) {
    case 'corn':
    case 'silage corn':
    case 'summer corn':
      return CornCropBG;
    case 'sunflower':
      return SunflowerCropBG;
    case 'barley':
      return BarleyCropBG;
    case 'wheat':
      return WheatCropBG;
    case 'soybeans':
      return SoyabeanCropBG;
    default:
      return CornCropBG;
  }
};

export const HeroBanner0aWrapper = styled.div<
  { cropName: string } & HeroBanner0aWrapperProps
>`
  background-repeat: no-repeat;
  position: relative;
  background-size: cover;
  background-image: linear-gradient(
      164deg,
      rgba(6, 67, 28, 0.85) 22.54%,
      rgba(11, 10, 44, 0.73) 114.76%
    ),
    url(${({ cropName }) => getCropImage(cropName)});
  width: 100%;
  text-align: center;
  color: #fff;

  .leaflet-image {
    position: absolute;
    right: 64px;
    top: 40px;
  }
`;

export const HeroBanner0aSection = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${({ isMobile }) => (isMobile ? '24px 16px' : '40px 64px')};
  position: relative;

  .hero-banner-first-section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const HeroBanner0aTitle = styled.div`
  width: max-content;
  padding: 2px 4px;
  font-weight: 600;
  line-height: 16px;
  border-radius: 4px;
  background: rgba(35, 38, 48, 0.5);
`;

export const HeroBanner0aUserName = styled.h3`
  font-size: 30px;
  font-weight: 600;
  line-height: 38px;
  border-radius: 4px;
  text-align: justify;
  margin: 0;
  color: #fff;
`;

export const HeroBanner0aDate = styled.div`
  width: max-content;
  min-width: 242px;
  height: 31px;
  border-radius: 26px 0px;
  background: var(--Green-green-40, #5ebb7f);
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0px 19px;
  margin-top: 12px;
`;

export const HeroBanner0aFieldInfo = styled.div`
  border-radius: 8px;
  border: 1px solid var(--Border-Default-Border-Default-Disabled-Primary, #C2C7D0);
  display: flex;
  font-size: 16px;
  padding: 12px 12px;
  align-items: center;
  justify-content: center;
  width: max-content;
  margin-top: 24px;

  .white-dot {
    width: 6px;
    height: 6px;
    background-color: white;
    border-radius: 50%;
    margin: 0px 8px;
  }

  .icon-size {
    width: 16px;
    height: 16px;
  }

  .field-image {
    margin-right: 6px;
  }

  .separator-icon {
    width: 1px;
    height: 16px;
    margin: 0 16px;
  }

  .crop-icon {
    margin-right: 8px;
  }
`;
